<template>
    <div class="setting">
        <alert-component :status="alertStatus" v-show="alertShow" :alert-message="alertMessage"></alert-component>
        <span class="setting-label">{{ title }}</span>
        <form>
            <label v-for="option in options">
                <input type="radio" @click="saveSetting(option.value)" v-model="settingValue" :value="option.value">
                {{ option.label }}
            </label>
        </form>
    </div>
</template>

<script>
    import axios from 'axios'
    import AlertComponent from './AlertComponent.vue'
    export default {
        components: { AlertComponent },
        props: {
            setting: {
                required: true,
                type: String
            },
            currentSetting: {
                required: true
            },
            title: {
                required: true,
                type: String,
                default: ''
            },
            options: {
                required: true,
                validator: value => Array.isArray(value) && value.length > 0 && value.length === value.filter(
                    option => (typeof option === 'object') && option.hasOwnProperty('value') && option.hasOwnProperty('label')
                ).length
            },
            errorMessage: {
                required: true,
                type: String,
                default: '',
            },
            successMessage: {
                required: true,
                type: String,
                default: '',
            }
        },
        data() {
            return {
                settingValue: 0,
                alertStatus: 'error',
                alertShow: false,
                alertMessage: ''
            }
        },
        methods: {
            saveSetting (value) {
                axios.post('/settings/video', {
                    setting: this.setting,
                    value: value
                }).then(() => {
                    this.trackMixpanel(value);
                    this.alertStatus = 'success';
                    this.alertMessage = this.successMessage;
                    this.alertShow = true;
                    this.closeAlert();
                }).catch(() => {
                    this.alertStatus = 'error';
                    this.alertMessage = this.errorMessage;
                    this.alertShow = true;
                    this.closeAlert();
                });
            },
            trackMixpanel (actionData) {
                let mixPanelData = {};
                mixPanelData.action_type = 'ChangedSetting';
                mixPanelData.action_target = this.setting;
                mixPanelData.action_data = actionData;
                mixPanelData.action_location = window.location.href;
                mixpanel.track("TriggeredAction", mixPanelData)
            },
            closeAlert () {
                this.alertTimeout && clearTimeout(this.alertTimeout);

                this.alertTimeout = setTimeout(() => {
                    this.alertShow = false;
                }, 3000);
            }
        },
        mounted () {
            this.settingValue = this.currentSetting
        }
    }
</script>
